import script from "./PaymentMethodCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodCard.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodCard.vue?vue&type=style&index=0&id=acf1c982&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acf1c982"]])

export default __exports__